export default __webpack_public_path__ + "files/7e7cb21116dd9801c2659c3c178fa156.png";